import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.b5y_1 = call;
        this.c5y_1 = responseData.h5j_1;
        this.d5y_1 = responseData.c5j_1;
        this.e5y_1 = responseData.f5j_1;
        this.f5y_1 = responseData.d5j_1;
        this.g5y_1 = responseData.i5j_1;
        var tmp = this;
        var tmp_0 = responseData.g5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.h5y_1 = tmp0_elvis_lhs == null ? Companion_getInstance().y4j_1 : tmp0_elvis_lhs;
        this.i5y_1 = responseData.e5j_1;
      }
      n5i() {
        return this.b5y_1;
      }
      xv() {
        return this.c5y_1;
      }
      w5i() {
        return this.d5y_1;
      }
      x5i() {
        return this.e5y_1;
      }
      y5i() {
        return this.f5y_1;
      }
      z5i() {
        return this.g5y_1;
      }
      v5i() {
        return this.h5y_1;
      }
      f50() {
        return this.i5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
